import { useCallback, useEffect } from "react";
import { useFormikContext } from "formik";
import * as Yup from "yup";
import { InputAdornment, Stack, TextField, Typography } from "@mui/material";
import { Phone, User as UserIcon } from "lucide-react";
import { useUserProfile } from "@/hooks";
import { AnonymousUser } from "@/types";
import InputMask from "react-input-mask";
import isEmpty from "lodash/isEmpty";
import { ReservationSharedProps } from "@/pages/reservations/ReservationsPage";
import { sanitizePhone } from "@/utils/phones";

export const ContactFormSchema = Yup.object().shape({
  name: Yup.string().required("Campo requerido"),
  lastname: Yup.string().required("Campo requerido"),
  phone: Yup.string().min(8, "Muy Corto!").max(8, "Muy Largo!").required("Campo requerido"),
});

export type IContactForm = Partial<AnonymousUser>;

export const contactFormInitialValues: IContactForm = {
  id: "",
  name: "",
  lastname: "",
  phone: "",
};

export const contactFormFields = Object.keys(contactFormInitialValues);

export const onSubmitContactForm = async (values: IContactForm, sharedProps: ReservationSharedProps) => {
//
};

const ContactForm = () => {
  const formik = useFormikContext<IContactForm>();
  const { activeUser } = useUserProfile();

  const initializeData = useCallback(() => {
    if (!isEmpty(formik.values.name)) return;

    if (activeUser) {
      formik.setValues({
        ...formik.values,
        name: activeUser?.name || "",
        lastname: activeUser?.lastname || "",
        phone: activeUser?.phone || "",
      });
    }
  }, [activeUser]);

  useEffect(() => {
    initializeData();
  }, [initializeData]);

  return (
    <Stack spacing={2}>
      <Typography textAlign="center" variant="h4">¿A nombre de quién reservaremos?</Typography>
      <TextField
        name="name"
        label="Nombre"
        value={formik.values.name}
        error={!!formik.touched.name && !!formik.errors.name && !!formik.handleBlur}
        helperText={!!formik.touched.name && formik.errors.name}
        onBlur={formik.handleBlur}
        onChange={formik.handleChange}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <UserIcon />
              </InputAdornment>
            ),
          },
        }}
      />
      <TextField
        name="lastname"
        label="Apellido"
        value={formik.values.lastname}
        error={!!formik.touched.lastname && !!formik.errors.lastname && !!formik.handleBlur}
        helperText={!!formik.touched.lastname && formik.errors.lastname}
        onBlur={formik.handleBlur}
        onChange={formik.handleChange}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <UserIcon />
              </InputAdornment>
            ),
          },
        }}
      />

      <InputMask
        mask="9999-9999"
        placeholder="0000-0000"
        alwaysShowMask={false}
        value={formik.values.phone}
        onChange={(e) => {
          formik.setFieldValue("phone", sanitizePhone(e.target.value));
        }}
        onBlur={formik.handleBlur}
      >
        {() => (
          <TextField
            label="Celular"
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <Phone />
                  </InputAdornment>
                ),
              },
            }}
            name="phone"
            error={!!formik.touched.phone && !!formik.errors?.phone}
            helperText={formik.touched.phone && formik.errors?.phone}
          />
        )}
      </InputMask>
    </Stack>
  );
};

export default ContactForm;
